/**
 * Does a hierarchy row match the sidebar's filter? On the name it shows, and
 * for a screen also on its key (`name_clean`) — never shown in the tree, but
 * what the rest of the app identifies a screen by, so it is what people type.
 *
 * @param query already trimmed and lower-cased
 */
export const matchesHierarchyFilter = (
	row: { name: string; nameClean?: string },
	query: string
): boolean =>
	query !== "" &&
	(row.name.toLocaleLowerCase().includes(query) ||
		(row.nameClean ?? "").toLocaleLowerCase().includes(query));
